import { DOCUMENT } from '@angular/common';
import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';

import { environment } from '../../environments/environment';

/**
 * Opens the TCP/TLS connection to the media origin before the PDP hero image is requested, so the
 * LCP image starts downloading a full round-trip earlier. Runs during app init, which on the
 * server means the tag is part of the SSR HTML head (RBA-2280). Also satisfies the NgOptimizedImage
 * preconnect assertion (NG02956) for `priority` images.
 */
export function provideMediaPreconnect(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const origin = environment.mediaOrigin;
    if (!origin) {
      return;
    }
    const document = inject(DOCUMENT);
    if (document.head.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    document.head.appendChild(link);
  });
}
